import React from 'react'

import '../../../styles/About/Route/Intro.scss'
const Intro = () => {
    return (
        <>
            <div className="about-intro">
                <div className="about-intro__container">
                    <div className="about-intro__header">
                        <h2 className="about-intro__number">0<span>1</span></h2>
                        <h1 data-aos='fade-down' data-aos-offset="0">H<span>ello</span>.</h1>
                    </div>
                    <div className="about-intro__description">
                        <p data-aos='fade-right' >I am <span>Nandani Gupta</span></p>
                        <p data-aos='fade-right' data-aos-delay='200'>Hard-working bca data science student with 5 months of consultancy 
internship experience.</p>
                        <p data-aos='fade-right' data-aos-delay='400'>Adapt at leveraging deep learning frameworks and 
AI techniques to create cutting-edge generative models that solve 
complex problems and enhance user experiences.</p>
                        <p data-aos='fade-right' data-aos-delay='600'> Seeking to contribute 
expertise in artificial intelligence, machine learning, and data science to 
drive innovation and deliver impactful AI solutions. 
</p>
                       

                        <div className="about-intro__emoji">:&nbsp;)</div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Intro